import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchData = createAsyncThunk(
  "dashboard/fetchData",
  async (msToken) => {
    const response = await axios.get(`${window.ENV.url}/Admin_Dashboard`, {
      headers: {
        token: msToken,
      },
    });

    if (response?.data?.state === 200) {
      const result = response.data.resault;
      result.visitedPages = result.visitedPages.map((vP) => ({
        ...vP,
        id: vP.pageID,
      }));

      return result;
    } else {
      throw new Error("Request failed");
    }
  }
);

export const counterSlice = createSlice({
  name: "counter",
  initialState: {
    data: [],
    loading: false,
    error: false,
  },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload.amount;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        console.log("✅ FULFILLED payload:", action.payload);

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        console.log("❌ REJECTED:", action.error);

        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { increment, decrement, incrementByAmount } = counterSlice.actions;
export default counterSlice.reducer;
